import type { IconData } from '@stacksjs/iconify-core'

export const padlockAltOpenF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 9.528V4a4 4 0 1 1 8 0v1a1 1 0 1 1-2 0V4a2 2 0 1 0-4 0v4.341a6 6 0 1 1-2 1.186zM6 16a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default padlockAltOpenF
